import paper from 'paper';

export function scaleSVG(SVG, canvasEl, isFullscreen) {
  const { height, width } = canvasEl.getBoundingClientRect();
  const mask = new paper.Rectangle(
    width - (95 / 100) * width,
    isFullscreen ? 0 : (12.5 / 100) * height,
    width - (20 / 100) * width,
    isFullscreen ? height : height - (25 / 100) * height
  );

  SVG.fitBounds(mask);
}
